import { DEFAULT_UPLOAD_TIMEFRAME, UPLOAD_TIMEFRAME_OPTIONS } from "./patternFilters";

/**
 * Query keys the Patterns page reads once on load to seed filter state (not kept in sync with the URL).
 */
export const PATTERNS_URL_QUERY_ALLOWLIST = ["creator", "uploaded"];

const UPLOAD_VALUES = new Set(UPLOAD_TIMEFRAME_OPTIONS.map((o) => o.value));

/**
 * Parse allowlisted search params for initial Patterns filters (call from useState initializer).
 */
export function parsePatternsUrlSearch(searchString) {
  const params = new URLSearchParams(searchString || "");
  const creator = (params.get("creator") || "").trim() || null;
  const rawUploaded = (params.get("uploaded") || "").trim().toLowerCase();
  const uploaded = UPLOAD_VALUES.has(rawUploaded) ? rawUploaded : null;
  return {
    creatorHash: creator,
    uploadTimeframe: uploaded != null ? uploaded : DEFAULT_UPLOAD_TIMEFRAME,
    uploadTimeframeExplicit: uploaded != null,
  };
}
